<template>
    <div class="desktop-page">
        <div class="desktop-bg"></div>
        <div class="top-bar">
            <el-dropdown v-if="roleName == '管理员'" @command="handleSettingCommand" trigger="click">
                <el-button icon="el-icon-setting" type="primary" size="small">设置</el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="procSendAudit">配置加工送货单联审</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button icon="el-icon-switch-button" type="danger" size="small" @click="logback">退出登录</el-button>
        </div>
        <div class="desktop-content">
            <div class="welcome-section">
                <div class="welcome-icon">
                    <img src="../assets/favicon.png" alt="logo" />
                </div>
                <h1 class="welcome-title">欢迎使用凌丰供应商系统</h1>
                <p class="welcome-subtitle">LINKFAIR SUPPLIER MANAGEMENT SYSTEM</p>
            </div>
            <div class="menu-grid">
                <div class="menu-card" @click="gotobuy">
                    <div class="menu-icon-wrap">
                        <img src="../assets/buy.png" alt="采购订单" />
                    </div>
                    <div class="menu-text">采购订单（总览）</div>
                </div>
                <div class="menu-card" @click="gotoBuyItem">
                    <div class="menu-icon-wrap">
                        <img src="../assets/buy.png" alt="采购订单子项" />
                    </div>
                    <div class="menu-text">采购订单（明细）</div>
                </div>
                <div class="menu-card" @click="gotosend">
                    <div class="menu-icon-wrap">
                        <img src="../assets/send.png" alt="采购送货单" />
                    </div>
                    <div class="menu-text">采购送货单</div>
                </div>
                <div class="menu-card" v-if="roleName == '管理员' || roleName == '财务员' || roleName == '仓管员'" @click="gotouserManager">
                    <div class="menu-icon-wrap">
                        <img src="../assets/user.png" alt="供应商门户" />
                    </div>
                    <div class="menu-text">供应商门户</div>
                </div>
                <div class="menu-card" @click="gotoProc">
                    <div class="menu-icon-wrap">
                        <img src="../assets/proc.png" alt="加工单" />
                    </div>
                    <div class="menu-text">加工单</div>
                </div>
                <div class="menu-card" @click="gotoProcSend">
                    <div class="menu-icon-wrap">
                        <img src="../assets/proc_send.png" alt="加工送货单" />
                    </div>
                    <div class="menu-text">加工送货单</div>
                </div>
                <div class="menu-card" v-if="roleName == '管理员' || roleName == '财务员' || roleName == '仓管员'" @click="gotoProcUser">
                    <div class="menu-icon-wrap">
                        <img src="../assets/proc_supplier.png" alt="加工商门户" />
                    </div>
                    <div class="menu-text">加工商门户</div>
                </div>
                <div class="menu-card" v-if="roleName == '管理员'" @click="gotoFileManage">
                    <div class="menu-icon-wrap">
                        <i class="el-icon-folder-opened menu-icon-font"></i>
                    </div>
                    <div class="menu-text">文件管理</div>
                </div>
            </div>
            <div class="desktop-footer">
                <span>© 2024 LINKFAIRTECH 版权所有</span>
            </div>
        </div>
        
        <el-dialog :visible.sync="auditorDialogShow" width="640px" :close-on-click-modal="false" custom-class="auditor-dialog">
            <div slot="title" class="auditor-dialog-title">
                <i class="el-icon-s-check"></i>
                <span>配置加工送货单联审</span>
            </div>
            <div class="auditor-section">
                <div class="auditor-section-title">联审设置</div>
                <el-form label-width="80px" size="small" class="auditor-form">
                    <el-form-item label="单据类型">
                        <el-select v-model="auditorFormType" style="width: 100%;" placeholder="请选择单据类型" @change="queryAuditors">
                            <el-option label="电箱物料" value="Elect"></el-option>
                            <el-option label="机械物料" value="Common"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联审人员" style="margin-bottom: 0;">
                        <el-select v-model="auditorIds" multiple filterable clearable style="width: 100%;" placeholder="请选择联审人员">
                            <el-option v-for="item in userOptions" :key="item.id" :label="item.userName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="auditor-section">
                <div class="auditor-table-bar">
                    <div class="auditor-section-title" style="margin-bottom: 0;">
                        当前联审人员
                        <span class="auditor-count">{{ auditorTableData.length }} 人</span>
                    </div>
                    <div class="auditor-table-tools">
                        <el-select v-model="auditorTableType" size="mini" style="width: 110px;" placeholder="分类" @change="queryAuditorTable">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="电箱物料" value="Elect"></el-option>
                            <el-option label="机械物料" value="Common"></el-option>
                        </el-select>
                        <el-button size="mini" type="primary" plain icon="el-icon-refresh" @click="queryAuditorTable">刷新</el-button>
                    </div>
                </div>
                <el-table :data="auditorTableData" border stripe size="mini" max-height="260" v-loading="auditorTableLoading">
                    <el-table-column label="序号" width="60" align="center">
                        <template slot-scope="{ $index }">
                            <span>{{ $index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="联审人员" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-user" style="margin-right: 4px; color: #909399;"></i>{{ getAuditorName(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="单据类型" width="120" align="center">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="scope.row.formType == 'Elect' ? 'success' : 'warning'">
                                {{ scope.row.formType == 'Elect' ? '电箱物料' : '机械物料' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <template slot="empty">
                        <span style="color: #909399;">暂无联审人员</span>
                    </template>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="auditorDialogShow = false">取 消</el-button>
                <el-button type="success" size="small" @click="saveAuditors">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as auditorsApi from "@/Api/auditorsApi";
import * as userApi from "@/Api/userApi";
export default {
    name: "desktop",
    data() {
        return {
            roleName: sessionStorage.getItem("roleName"),
            auditorDialogShow: false,
            auditorFormType: "Elect",
            auditorIds: [],
            userOptions: [],
            auditorTableData: [],
            auditorTableType: "",
            auditorTableLoading: false,
        };
    },
    methods: {
        handleSettingCommand(command) {
            if (command == "procSendAudit") {
                this.openAuditorDialog();
            }
        },
        openAuditorDialog() {
            this.auditorDialogShow = true;
            //查询可选用户列表
            userApi
                .userQuery({ userName: "", roleId: "", supplierId: "", pageSize: 1000, currentPage: 1 }, this)
                .then((res) => {
                    this.userOptions = res.records;
                })
                .catch(() => {});
            //查询当前审核人设置
            this.queryAuditors();
            //查询审核人表格数据
            this.queryAuditorTable();
        },
        queryAuditors() {
            auditorsApi
                .getAuditor({ formType: this.auditorFormType }, this)
                .then((res) => {
                    this.auditorIds = (res || []).map((item) => item.id);
                })
                .catch(() => {});
        },
        saveAuditors() {
            auditorsApi
                .saveAuditor({ formType: this.auditorFormType, auditorIds: this.auditorIds }, this)
                .then(() => {
                    this.$message.success("保存成功");
                    this.queryAuditorTable();
                })
                .catch(() => {});
        },
        queryAuditorTable() {
            this.auditorTableLoading = true;
            const types = this.auditorTableType ? [this.auditorTableType] : ["Elect", "Common"];
            Promise.all(
                types.map((type) =>
                    auditorsApi
                        .getAuditor({ formType: type }, this)
                        .then((res) => (res || []).map((item) => ({ ...item, formType: type })))
                        .catch(() => [])
                )
            )
                .then((lists) => {
                    this.auditorTableData = [].concat(...lists);
                })
                .finally(() => {
                    this.auditorTableLoading = false;
                });
        },
        getAuditorName(row) {
            if (row.userName) return row.userName;
            const user = this.userOptions.find((item) => item.id == (row.id || row));
            return user ? user.userName : "";
        },
        gotobuy() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/buyOverview",
            });
            window.open(href, "_blank");
        },
        gotoBuyItem() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/buyPage",
            });
            window.open(href, "_blank");
        },
        gotosend() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/sendPage",
            });
            window.open(href, "_blank");
        },
        gotouserManager() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/userManager",
            });
            window.open(href, "_blank");
        },
        gotoProc() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/proc",
            });
            window.open(href, "_blank");
        },
        gotoProcSend() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/procSend",
            });
            window.open(href, "_blank");
        },
        gotoProcUser() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/procUser",
            });
            window.open(href, "_blank");
        },
        gotoFileManage() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: "/fileManage",
            });
            window.open(href, "_blank");
        },
        logback() {
            this.$confirm("退出登录", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    sessionStorage.clear();
                    this.$router.push("/login");
                })
                .catch(() => {});
        },
    },
    mounted() {},
    created() {},
};
</script>

<style scoped>
.desktop-page {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.desktop-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #12b4bd 0%, #0e8f96 30%, #0a6b70 60%, #085256 100%);
    opacity: 0.95;
}

.desktop-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    width: 100%;
    max-width: 900px;
}

.top-bar {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.auditor-dialog-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.auditor-dialog-title i {
    color: #12b4bd;
    font-size: 18px;
}

.auditor-section {
    background: #f7fafa;
    border: 1px solid #e4edef;
    border-radius: 8px;
    padding: 14px 16px;
    margin-bottom: 16px;
}

.auditor-section:last-of-type {
    margin-bottom: 0;
}

.auditor-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #12b4bd;
    line-height: 1.2;
}

.auditor-count {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    background: #12b4bd;
    border-radius: 10px;
    padding: 1px 8px;
    margin-left: 6px;
}

.auditor-table-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.auditor-table-tools {
    display: flex;
    gap: 8px;
}

.auditor-form .el-form-item {
    margin-bottom: 12px;
}

.auditor-dialog .el-dialog__body {
    padding: 16px 20px;
}

.auditor-dialog .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
    padding: 14px 20px;
}

.auditor-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 12px 20px;
}

.top-bar .el-button {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #fff;
}

.top-bar .el-button:hover {
    background: rgba(255, 255, 255, 0.3);
}

.welcome-section {
    text-align: center;
    margin-bottom: 50px;
}

.welcome-icon {
    width: 120px;
    height: 120px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 20px;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%,
    100% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.05);
        opacity: 0.8;
    }
}

.welcome-icon img {
    width: 80px;
    height: 80px;
    object-fit: contain;
}

.welcome-title {
    font-size: 42px;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
    margin-bottom: 10px;
}

.welcome-subtitle {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    letter-spacing: 4px;
}

.menu-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    width: 100%;
    max-width: 720px;
}

.menu-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.menu-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
    background: #fff;
}

.menu-icon-wrap {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #e8f8f9 0%, #d4f1f2 100%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    transition: all 0.3s ease;
}

.menu-card:hover .menu-icon-wrap {
    transform: scale(1.1);
    background: linear-gradient(135deg, #12b4bd 0%, #0e8f96 100%);
}

.menu-icon-wrap img {
    width: 48px;
    height: 48px;
    transition: all 0.3s ease;
}

.menu-icon-font {
    font-size: 44px;
    color: #12b4bd;
    transition: all 0.3s ease;
}

.menu-card:hover .menu-icon-font {
    color: #fff;
}

.menu-card:hover .menu-icon-wrap img {
    filter: brightness(0) invert(1);
}

.menu-text {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.desktop-footer {
    margin-top: 50px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
}

@media (max-width: 768px) {
    .menu-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
    }

    .welcome-title {
        font-size: 28px;
    }
}
</style>